export const projects = [
  {
    title: "UpShare",
    subtitle: "getupshare.com",
    description: "Powered by Vaprix Group Limited, UpShare provides public ShareX uploader service.",
    image: "https://phanmemnet.com/wp-content/uploads/2021/02/ShareX.png",
    link: "https://getupshare.com",
    status: <span className="text-red-400">⬤ In-Progress</span>
  },
  {
    title: "TukeBackdoor",
    subtitle: "Available in my GitHub profile",
    description:
      "Custom backdoor solution, destroy any P2W servers, and stay as fuck hidden.",
    image: "https://external-preview.redd.it/yz4OjPn8Pw8FY7q7vfCXboDfrpinET85cWJA2f-EkB8.jpg?auto=webp&s=f5d59dfeb8615c9bdb60dd3b5edf4e4e8bfe55c6",
    link: "https://github.com/adreaisbad/TukeBackdoor/wiki",
    status: <span className="text-yellow-400">⬤ Private</span>
  },
];
